/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TypographyNodeName_Node = {
    readonly groupName?: string | null | undefined;
    readonly name?: string | null | undefined;
    readonly facilityName?: string | null | undefined;
    readonly " $refType": "TypographyNodeName_Node";
};
export type TypographyNodeName_Node$data = TypographyNodeName_Node;
export type TypographyNodeName_Node$key = {
    readonly " $data"?: TypographyNodeName_Node$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TypographyNodeName_Node">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TypographyNodeName_Node",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "groupName",
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "type": "Group",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "Patient",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "Provider",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "facilityName",
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "type": "Facility",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();
(node as any).hash = '87e36ed638d54e3ff0c816659c46839f';
export default node;
